import { render, staticRenderFns } from "./BootstrapRadio.vue?vue&type=template&id=a233cf28"
import script from "./BootstrapRadio.vue?vue&type=script&lang=js"
export * from "./BootstrapRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports